module.exports = __webpack_public_path__ + "img/bio.32bfb481.png";